import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkHeader, setIsDarkHeader] = useState(() => {
    const saved = localStorage.getItem('header-theme');
    return saved === 'dark';
  });

  const toggleHeaderTheme = () => {
    setIsDarkHeader(prev => {
      const newValue = !prev;
      localStorage.setItem('header-theme', newValue ? 'dark' : 'light');
      return newValue;
    });
  };

  const value = {
    isDarkHeader,
    toggleHeaderTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
